import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Search, MessageCircle, Book, Phone, Mail, ChevronRight, HelpCircle } from 'lucide-react';
export function HelpPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const categories = [{
    title: 'Getting Started',
    icon: Book,
    articles: ['How to create an account', 'Verifying your identity', 'Understanding plot listings', 'Making your first inquiry']
  }, {
    title: 'Buying Land',
    icon: HelpCircle,
    articles: ['How to search for plots', 'Understanding trust badges', 'Scheduling site visits', 'Making an offer']
  }, {
    title: 'Selling Land',
    icon: HelpCircle,
    articles: ['Creating a listing', 'Pricing your property', 'Managing inquiries', 'Completing a sale']
  }, {
    title: 'Legal & Compliance',
    icon: HelpCircle,
    articles: ['Required documents', 'RERA compliance', 'Title verification', 'Tax implications']
  }];
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-4102">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-4103">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-4104">
          <Link to="/" className="flex items-center gap-2" data-id="element-4105">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-4106"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-4107">
              Citiplots.com
            </span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-4108">
            <Link to="/" data-id="element-4109">Home</Link>
            <Link to="/faq" data-id="element-4110">FAQ</Link>
            <Link to="/contact" data-id="element-4111">Contact</Link>
            <Link to="/help" className="text-[#1f2933]" data-id="element-4112">
              Help Center
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1" data-id="element-4113">
        {/* Hero Section */}
        <section className="bg-white border-b border-gray-300 py-16 px-6 text-center" data-id="element-4114">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-4115">
            How can we help you?
          </h1>
          <p className="text-lg text-gray-500 mb-8 font-mono" data-id="element-4116">
            Search our knowledge base or contact support
          </p>

          <div className="max-w-2xl mx-auto relative" data-id="element-4117">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-4118" />
            <input type="text" placeholder="Search for help articles..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-4 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 font-mono text-sm" data-id="element-4119" />
          </div>
        </section>

        {/* Help Categories */}
        <section className="max-w-6xl mx-auto px-6 py-16" data-id="element-4120">
          <h2 className="text-2xl font-bold mb-8" data-id="element-4121">Browse by Category</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4122">
            {categories.map((category, i) => <div key={i} className="bg-white border border-gray-300 p-6" data-id="element-4123">
                <div className="flex items-center gap-3 mb-4" data-id="element-4124">
                  <category.icon className="w-6 h-6 text-gray-600" data-id="element-4125" />
                  <h3 className="font-bold text-lg" data-id="element-4126">{category.title}</h3>
                </div>
                <ul className="space-y-3" data-id="element-4127">
                  {category.articles.map((article, j) => <li key={j} data-id="element-4128">
                      <Link to="#" className="flex items-center justify-between text-sm text-gray-700 hover:text-[#1f2933] group" data-id="element-4129">
                        <span data-id="element-4130">{article}</span>
                        <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-[#1f2933]" data-id="element-4131" />
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </section>

        {/* Contact Support */}
        <section className="bg-white border-t border-gray-300 py-16 px-6" data-id="element-4132">
          <div className="max-w-4xl mx-auto" data-id="element-4133">
            <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-4134">
              Still need help?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4135">
              <div className="border border-gray-300 p-6 text-center" data-id="element-4136">
                <MessageCircle className="w-8 h-8 mx-auto mb-3 text-gray-600" data-id="element-4137" />
                <h3 className="font-bold mb-2" data-id="element-4138">Live Chat</h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-4139">
                  Chat with our support team
                </p>
                <button className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-4140">
                  Start Chat
                </button>
              </div>

              <div className="border border-gray-300 p-6 text-center" data-id="element-4141">
                <Mail className="w-8 h-8 mx-auto mb-3 text-gray-600" data-id="element-4142" />
                <h3 className="font-bold mb-2" data-id="element-4143">Email Support</h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-4144">Get help via email</p>
                <Link to="/contact" className="inline-block px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-4145">
                  Send Email
                </Link>
              </div>

              <div className="border border-gray-300 p-6 text-center" data-id="element-4146">
                <Phone className="w-8 h-8 mx-auto mb-3 text-gray-600" data-id="element-4147" />
                <h3 className="font-bold mb-2" data-id="element-4148">Phone Support</h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-4149">
                  Mon-Fri, 9AM-6PM IST
                </p>
                <a href="tel:+911234567890" className="inline-block px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-4150">
                  Call Us
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-4151" />
    </div>;
}